webpackJsonp([123923693251328],{

/***/ "./src/components/PostPreview.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PostPreview = function (_React$Component) {
	  _inherits(PostPreview, _React$Component);
	
	  function PostPreview() {
	    _classCallCheck(this, PostPreview);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PostPreview.prototype.render = function render() {
	
	    var post = this.props;
	
	    var tags = null;
	    if (post.frontmatter.tags) {
	      tags = post.frontmatter.tags.split(',').map(function (tag) {
	        return _react2.default.createElement(
	          _gatsbyLink2.default,
	          { key: tag, to: 'tag/' + tag },
	          tag
	        );
	      });
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'blog-post-preview', key: post.frontmatter.path, style: { backgroundImage: post.frontmatter.bg } },
	      _react2.default.createElement(
	        'div',
	        { className: 'blog-post-link' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: post.frontmatter.path, className: 'blog-post-title' },
	          post.frontmatter.title
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'blog-post-date' },
	          post.frontmatter.date
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'blog-post-excerpt' },
	          post.excerpt
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'blog-post-tags' },
	          tags
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: post.frontmatter.path, className: 'blog-post-read-more' },
	          'Read ',
	          post.frontmatter.title
	        )
	      ),
	      _react2.default.createElement(
	        'a',
	        { className: 'blog-post-bg-attribution', href: post.frontmatter.bgLink },
	        post.frontmatter.bgTitle,
	        ' by ',
	        post.frontmatter.bgAuthor
	      )
	    );
	  };
	
	  return PostPreview;
	}(_react2.default.Component);
	
	exports.default = PostPreview;
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/opt/build/repo/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/opt/build/repo/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/opt/build/repo/node_modules/babel-preset-stage-0/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/templates/blog-tags.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.tagsQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Tags;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _PostPreview = __webpack_require__("./src/components/PostPreview.js");
	
	var _PostPreview2 = _interopRequireDefault(_PostPreview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Tags(_ref) {
	    var pathContext = _ref.pathContext,
	        data = _ref.data;
	    var _data$site$siteMetada = data.site.siteMetadata,
	        title = _data$site$siteMetada.title,
	        siteUrl = _data$site$siteMetada.siteUrl;
	    var posts = pathContext.posts,
	        tag = pathContext.tag,
	        pagesSum = pathContext.pagesSum,
	        page = pathContext.page;
	
	
	    return _react2.default.createElement(
	        'section',
	        null,
	        _react2.default.createElement(
	            'nav',
	            { className: 'blog-section' },
	            _react2.default.createElement(
	                'span',
	                { className: 'blog-section-link' },
	                'Tag / ',
	                tag
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'posts' },
	            posts.map(function (post) {
	                return _react2.default.createElement(_PostPreview2.default, _extends({ key: post.frontmatter.path }, post));
	            })
	        )
	    );
	}
	
	var tagsQuery = exports.tagsQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-blog-tags-js-f54ac6e21bcf8a7c9c77.js